export class CartService {
  constructor(gaApp) {
    this.gaApp = gaApp
  }

  /** Отправка события на добавление продукта в корзину */
  addItem(item) {
    this.gaApp.services.app.bridge.sendAddToCartMessage(item.id)
  }
}
